/**
 * Created by ZengFanHui on 18/05/04.
 */
import * as types from './mutations-types'

const mutations = {
  [types.SET_SUB_MENU_LIST] (state, subMenuList) {
    state.subMenuList = subMenuList
  },
  [types.SET_SUB_MENU_WIDTH] (state, width) {
    state.subMenuWidth = width
  },
  [types.SET_TABS] (state, obj) {
    let tab = state.tabs.find(f => f.name === obj.name)
    if (!tab) {
      state.tabs.push(obj)
    }
  },
  [types.SET_NEWTABS] (state, list) {
    state.tabs = list
  },
  [types.SET_SUB_MENU_ACTIVE_NAME] (state, name) {
    state.subMenuActiveName[0] = name
  },
  [types.SET_MENU_ACTIVE_NAME] (state, name) {
    state.menuActiveName = name
  },
  [types.SET_MENU_LIST] (state, list) {
    state.menuList = list
  },
  [types.SET_TOGGLE_MENU_FROM_WHERE] (state, where) {
    state.toggleMenuFromWhere = where
  },
  [types.SET_USERINFO] (state, userInfo) {
    state.userInfo = userInfo
  },
  [types.SET_ROLES] (state, moduleList) {
    let list = []
    let roles = roles4mate(list, moduleList)
    state.roles = roles
  },
  [types.SET_CURRENT_ROLES] (state, currentTitle) {
    let data = state.roles.find(item => {
      return item.name === currentTitle
    })
    state.currentRoles = data
  }
}

function roles4mate(list, data) {
  if (data === undefined) return
  data.forEach(item => {
    if (item.isMenu === 1 && (item.url === null || item.url === undefined)) { // 可展开的菜单
      if (item.childrenList !== undefined & item.childrenList !== null) {
        roles4mate(list, item.childrenList)
      }
    } else if (item.isMenu === 1 && item.url !== null) { // 可跳转的菜单
      let roles = {}
      if (item.childrenList !== undefined & item.childrenList !== null && item.childrenList.length > 0) {
        item.childrenList.forEach(role => {
          roles[role.name] = true
        })
      }
      list.push({
        name: item.name,
        roles
      })
    }
  })
  return list
}

export default mutations
